/* global BS */
const { DOM } = BS

const classPrefix = 'js-fe-'
const hideClass = 'hide'

BS.DOMReady(() => {
	const targets = [
		{
			container: DOM.q('.' + classPrefix + 'content-before'),
			input: DOM.q('[name*="[use_content_before]"]')
		},
		{
			container: DOM.q('.' + classPrefix + 'content-after'),
			input: DOM.q('[name*="[use_content_after]"]')
		}
	].filter(target => target.input != null);

	const update = () => {
		targets.forEach(target => {
			target.container.classList[target.input.checked ? 'remove' : 'add'](hideClass)
		})
	}

	targets.forEach(target => target.input.addEventListener('change', update))
	update()
})
